import React, { } from "react";
import "./TestPage.css";
// import { EditUser } from "../SchoolAdmin/Teachers";
import { LoadingSpinner } from "./Loader";
import GaugeChart from "react-gauge-chart";


const TestPage = () => {

  const GraphStyles = {
    arcColors: ["#F34970", "#F4C900", "#AABB5D", "#26C8B9"],
    graphBaseStyles: {
      top: "-15px",
      left: ""
    }
  }
  return (
    <div className="view">
      {/* <EditUser /> */}
      {false && < LoadingSpinner />}
      <GaugeChart id="gauge-chart1" nrOfLevels={4} colors={GraphStyles.arcColors}
        percent={0.86} arcPadding={0} cornerRadius={0} arcWidth={0.4} needleColor="#084059" needleBaseColor="#084059" textColor="#F4C900" fontSize="15px" />


      <h3>Custom Trial</h3>

      <div className="newGraph" style={{ top: GraphStyles.graphBaseStyles.top }}>
        <svg width="460" height="250" viewBox="0 0 432 216" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 215.461H60.4838C60.63 172.262 78.3856 133.209 106.954 105.116L64.1839 62.3438C24.6733 101.386 0.141507 155.555 0 215.461Z" fill="#F34970" />
          <path d="M64.1836 62.3419L106.954 105.114C135.018 77.511 173.51 60.4838 215.981 60.4838V0C156.808 0 103.198 23.7987 64.1836 62.3419Z" fill="#F4C900" />
          <path d="M215.98 0V60.4838C258.927 60.4838 297.804 77.8961 325.945 106.037L368.715 63.2722C349.173 43.7257 325.897 27.907 300.057 16.9762C274.219 6.04305 245.804 0 215.98 0Z" fill="#AABB5D" />
          <path d="M325.945 106.037C353.966 134.062 371.337 172.735 371.478 215.459H431.96C431.82 156.028 407.678 102.244 368.715 63.2715L325.945 106.037Z" fill="#26C8B9" />
        </svg>
        <svg className="blueGraphBar" width="460" height="16" viewBox="0 0 816 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 7.9707L808 7.9707" stroke="#084059" strokeWidth="15" strokeLinecap="round" />
        </svg>
        <svg className="blueGraphRoundNeedle" width="100" height="200" viewBox="0 0 203 401" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M191.35 3.66465e-09L79.6136 344.269L36.4737 325.565L191.35 3.66465e-09Z" fill="#084059" />
          <path d="M81.2281 335.619C81.6585 349.838 71.4982 361.748 58.5344 362.22C45.5706 362.692 34.7124 351.548 34.282 337.329C33.8516 323.11 44.0119 311.2 56.9758 310.728C69.9396 310.256 80.7977 321.4 81.2281 335.619Z" fill="#084059" />
          <rect y="308.083" width="92.1849" height="92.185" rx="46.0925" fill="#084059" />
        </svg>
        <svg className="dotted-graph-line" width="140" height="180" viewBox="0 0 140 327" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="138.534" y1="325.746" x2="1.0647" y2="0.672524" stroke="#084059" strokeWidth="2" strokeDasharray="2 2" />
        </svg>

      </div>

    </div >
  );
};

export { TestPage };
